import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-video-widget',
  templateUrl: './video-widget.component.html',
  styleUrls: ['./video-widget.component.scss']
})
export class VideoWidgetComponent implements OnInit {

  @Input() videos;
  constructor() { }

  ngOnInit(): void {
  }

}
